import { render, staticRenderFns } from "./invite_friends.vue?vue&type=template&id=446fc99e&scoped=true"
import script from "./invite_friends.vue?vue&type=script&lang=js"
export * from "./invite_friends.vue?vue&type=script&lang=js"
import style0 from "./invite_friends.vue?vue&type=style&index=0&id=446fc99e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446fc99e",
  null
  
)

export default component.exports